import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-brand-50 text-brand-800 ring-1 ring-inset ring-brand-200/60',
        accent: 'bg-accent-50 text-accent-800 ring-1 ring-inset ring-accent-200/60',
        ink: 'bg-ink text-ivory-50',
        ivory: 'bg-ivory-200/70 text-stone-700 ring-1 ring-inset ring-ivory-300/60',
        secondary: 'bg-stone-100 text-stone-700 ring-1 ring-inset ring-stone-200',
        outline: 'border border-stone-300 bg-surface text-stone-700',
        success: 'bg-green-50 text-green-700',
        warning: 'bg-yellow-50 text-yellow-700',
        error: 'bg-red-50 text-red-700',
        destructive: 'bg-red-50 text-red-700 ring-1 ring-inset ring-red-200',
      },
      size: {
        sm: 'px-2.5 py-0.5 text-[11px]',
        md: 'px-3 py-1 text-xs',
        lg: 'px-3.5 py-1.5 text-sm',
      },
    },
    defaultVariants: { variant: 'default', size: 'md' },
  },
);

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, size, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant, size }), className)} {...props} />;
}
